import { render, staticRenderFns } from "./EventCardTags.vue?vue&type=template&id=0a54dd2d&scoped=true"
import script from "./EventCardTags.vue?vue&type=script&lang=js"
export * from "./EventCardTags.vue?vue&type=script&lang=js"
import style0 from "./EventCardTags.vue?vue&type=style&index=0&id=0a54dd2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a54dd2d",
  null
  
)

export default component.exports